import { render, staticRenderFns } from "./review-resume.vue?vue&type=template&id=baac6614"
import script from "./review-resume.vue?vue&type=script&lang=js"
export * from "./review-resume.vue?vue&type=script&lang=js"
import style0 from "./review-resume.vue?vue&type=style&index=0&id=baac6614&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports